import React from "react";
import { Box, Flex, Spinner, Text, VStack } from "@chakra-ui/react";
import HomeRecentStockItem from "./HomeRecentStockItem";

const HomeRecentStocksSection = ({ recents, loading, error }) => (
  <Box
    bg="rgba(255, 255, 255, 0.5)"
    _dark={{ bg: "rgba(0, 0, 0, 0.3)" }}
    borderTopWidth="1px"
    py={6}
    px={6}
    mt={8}
    w="100%"
  >
    <VStack spacing={6} maxW="1200px" mx="auto" align="center">
      <Text fontSize="xl" fontWeight="semibold" textAlign="center">
        Recently visited
      </Text>
      {loading && <Spinner size="sm" />}
      {error && (
        <Text fontSize="sm" color="red.500" textAlign="center">
          {error}
        </Text>
      )}
      {!loading && !error && recents.length === 0 && (
        <Text fontSize="sm" color="gray.500" textAlign="center">
          Your recent stocks will appear here after you browse.
        </Text>
      )}
      {!loading && recents.length > 0 && (
        <Flex wrap="wrap" gap={4} justify="center">
          {recents.map((recent) => (
            <HomeRecentStockItem
              key={recent.symbol}
              symbol={recent.symbol}
              lastVisitedAt={recent.last_visited_at}
            />
          ))}
        </Flex>
      )}
    </VStack>
  </Box>
);

export default HomeRecentStocksSection;
